export const fetchNotesCount = /* GraphQL */ `query CountNotes($name: String!) {
    notesByDate(name: $name) {
      scannedCount,
      count
    }
}`;